<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Apparato Urogenitale" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Manovra di Giordano:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoUrogenitale.manovraGiordano }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoUrogenitale.manovraGiordano" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Punti Uretrali:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoUrogenitale.puntiUretrali }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoUrogenitale.puntiUretrali" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Diuresi:</label>
                            <span v-if="isReadOnly">{{ jsonDataApparatoUrogenitale.diuresi }}</span>
                            <b-form-textarea v-else v-model="jsonDataApparatoUrogenitale.diuresi" :readonly="isReadOnly" max-rows="5" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataApparatoUrogenitale: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    manovraGiordano: "",
                    puntiUretrali: "",
                    diuresi: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataApparatoUrogenitale: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaApparatoUrogenitale: "/rsaschedarelazionesanitariaapparatourogenitale",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaApparatoUrogenitale() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaApparatoUrogenitale + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaApparatoUrogenitaleSuccess, me.resultResponseSchedaRelazioneSanitariaApparatoUrogenitaleError);
        },

        resultResponseSchedaRelazioneSanitariaApparatoUrogenitaleSuccess(response) {
            let me = this;
            me.jsonDataApparatoUrogenitale = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaApparatoUrogenitaleError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataApparatoUrogenitale = {
                id: null,
                idAccettazione: this.idAccettazione,
                manovraGiordano: "",
                puntiUretrali: "",
                diuresi: "",
            };
        },

        onSalvaApparatoUrogenitale() {
            let me = this;
            me.jsonDataApparatoUrogenitale.idAccettazione = me.idAccettazione;
            if (!me.jsonDataApparatoUrogenitale.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaApparatoUrogenitale, me.jsonDataApparatoUrogenitale, me.saveSchedaRelazioneSanitariaApparatoUrogenitaleSuccessResponse, me.saveSchedaRelazioneSanitariaApparatoUrogenitaleErrorResponse);
        },
        saveSchedaRelazioneSanitariaApparatoUrogenitaleSuccessResponse() {},
        saveSchedaRelazioneSanitariaApparatoUrogenitaleErrorResponse() {
            console.error("Errore nel salvataggio dell'apparato urogenitale:");
        },
    },
};
</script>
